export const ALPHA_HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{8}$/;
export const URI_SCHEME_REGEX = /^(https?:\/\/)?(www\.)?/i;
